import React, { ReactNode, StyleHTMLAttributes } from 'react';
import { LuCheck } from 'react-icons/lu';
import { CheckboxContainer, Label, StyledCheckbox } from './styles';

type Props = {
    statusCheck: boolean;
    descriptionCheck: string | ReactNode;
    variant?: 'primary' | 'secondary';
    onClickCheck: () => void;
    customStyles?: StyleHTMLAttributes<HTMLDivElement>
};

export const Checkbox: React.FC<Props> = ({
    descriptionCheck,
    statusCheck,
    variant = 'primary',
    onClickCheck,
    customStyles
}) => {
    const id = React.useId();
    return (
        <CheckboxContainer {...customStyles}>
            <StyledCheckbox
                onClick={onClickCheck}
                aria-selected={variant === 'secondary'}
                aria-checked={statusCheck}
                id={id}
            >
                <LuCheck />
            </StyledCheckbox>
            <Label htmlFor={id}>{descriptionCheck}</Label>
        </CheckboxContainer>
    );
};
